<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M3210.25 35.38l-2822.18 0c-195.8,0 -352.79,156.99 -352.79,352.79l0 1940.21c0,195.8 156.99,352.79 352.79,352.79l705.58 -0.06 0 881.9 705.51 -352.79 705.51 352.79 0 -881.9 705.58 0c195.8,0 352.79,-157 352.79,-352.8l-0.06 -1940.21c0,-195.79 -157,-352.79 -352.79,-352.79l0.06 0.07zm0 2292.93l-2822.18 0 0 -352.79 2822.18 0.07 0 352.79 0 -0.07zm0 -881.9l-2822.18 0 0 -1058.31 2822.18 0 0 1058.31z"/>
 </g>
</svg>
